// Helper for enums: keeps both key-value and array of values
export function makeEnum<T extends Record<string, string>>(obj: T) {
  return {
    ...obj,
    values: Object.values(obj) as (typeof obj)[keyof typeof obj][],
  };
}

// Simple helper function to format enum values (capitalize first letter, rest lowercase)
export function formatEnumLabel(value: string | undefined): string {
  if(!value) {return "";}
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export const Enums = {
  ESTADO: makeEnum({
    ACTIVO: "ACTIVO",
    VENDIDO: "VENDIDO",
    MUERTO: "MUERTO",
    PERDIDO: "PERDIDO",
    RECARAVANEADO: "RECARAVANEADO"
  }),

  RAZA: makeEnum({
    HA: "HA", // Holando Argentino
    PH: "PH", // Polled Hereford
    J: "J", // Jersey
    LA: "LA", // Limangus
    FS: "FS", // Simmental
    SG: "SG", // Santa Gertrudis
    OR: "OR", // Otra Raza
    L: "L", // Limousine
    K: "K", // Kiwi
    BO: "BO", // Bosmara
    SRB: "SRB", // Sueca Roja y Blanca
    SA: "SA", // Senangus
    B: "B", // Brahman
    SH: "SH", // Shorthorn
    SP: "SP", // Senepol
    TL: "TL", // Tuli
    SI: "SI", // San Ignacio
    GC: "GC", // Ganado Cruza
    H: "H", // Hereford
    W: "W", // Wagyu
    SF: "SF", // Seneford
    CH: "CH", // Charolais
    AA: "AA", // Aberdeen Angus
    BG: "BG", // Brangus
    BF: "BF", // Braford
    CR: "CR", // Criolla
    MG: "MG", // Murray Grey
    G: "G", // Galloway
  }),

  CATEGORIA: makeEnum({
    TERNERO: "TERNERO",
    VACA: "VACA",
    VAQUILLONA: "VAQUILLONA",
    TORO: "TORO",
    NOVILLO: "NOVILLO",
    MEJ: "M.E.J",
  }),

  TIPO_EDAD: makeEnum({
    "2D": "2D",
    "4D": "4D",
    "6D": "6D",
    "BLL": "BLL",
    "3/4D": "3/4D",
    "1/2D": "1/2D",
    "1/4D": "1/4D",
    "S/D": "S/D",
    "VAQUILLONA": "VAQUILLONA",
    "NUEVA": "NUEVA",
    "VIEJA": "VIEJA"
    
  }),

  TIPO_PRENIEZ: makeEnum({
    VACIA: "VACIA",
    P1: "P1",
    P2: "P2",
    P3: "P3"
  }),

  SEXO: makeEnum({
    M: "M",
    H: "H",
  }),

  UBICACION_TIPO: makeEnum({
    CUADRO: "CUADRO",
    CORRAL: "CORRAL"
  }),

  PRECIO_TIPO: makeEnum({
    PER_UNIT: "perUnit",
    PER_KG: "perkg"
  }),
  
  TIPO_DE_OPERACION: makeEnum({
    COMPRA: "COMPRA",
    VENTA: "VENTA"
  })
};
